<div class="container-fluid mt-3">
    <div class="p-4 shadow-lg mb-3 rounded">
        <div class="row justify-content-center">
            <h5 class="text-secondary text-center">Solicitud de evaluación para capacidad de pago</h5>
            <hr width="90%">
        </div>
        <form #cpForm="ngForm" (submit)="registrar()">
            <div class="row justify-content-end">
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <div class="form-group text-center" [ngClass]="{ 'text-danger': validator(starDate, cpForm) }">
                        <label class="col-form-label col-form-label-sm">Día / Mes / Año</label>
                        <div class="input-group">
                            <input
                            type="text"
                            class="form-control form-control-sm text-center"
                            ngbDatepicker
                            name="starDate"
                            #d1="ngbDatepicker"
                            (click)="d1.toggle()"
                            placeholder="Día/Mes/Año"
                            [minDate]="hoy"
                            [maxDate]="hoy"
                            readonly
                            [(ngModel)]="paymentCapacity.date"
                            #starDate="ngModel"
                            >
                            <button class="btn btn-info btn-sm" (click)="d1.toggle()" type="button">
                                <i class="fa fa-calendar"></i>
                            </button>
                        </div>
                        <div *ngIf="validator(starDate, cpForm)">
                            <span *ngIf="starDate.errors?.required">Requerido</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <!-- <div class="form-group" [ngClass]="{ 'text-danger': validator(debtor, cpForm) }"> -->
                    <div class="form-group">
                        <label class="col-form-label col-form-label-sm">Cesion</label>
                        <ng-select
                        [items]="SPN1"
                        name="Cesion"
                        class="custom"
                        [virtualScroll]="true"
                        loadingText="Cargando por favor espere..."
                        placeholder="Selecciona"
                        notFoundText="No hay coincidencias"
                        clearAllText="Limpiar todo"
                        >
                        </ng-select>
                        <!-- <div *ngIf="validator(debtor, cpForm)">
                            <span *ngIf="debtor.errors?.required">Requerido</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <!-- <div class="form-group" [ngClass]="{ 'text-danger': validator(debtor, cpForm) }"> -->
                    <div class="form-group">
                        <label class="col-form-label col-form-label-sm">Rol</label>
                        <ng-select
                        [items]="SPN2"
                        name="Cesion"
                        class="custom"
                        [virtualScroll]="true"
                        loadingText="Cargando por favor espere..."
                        placeholder="Selecciona"
                        notFoundText="No hay coincidencias"
                        clearAllText="Limpiar todo"
                        >
                        </ng-select>
                        <!-- <div *ngIf="validator(debtor, cpForm)">
                            <span *ngIf="debtor.errors?.required">Requerido</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <!-- <div class="form-group" [ngClass]="{ 'text-danger': validator(debtor, cpForm) }"> -->
                    <div class="form-group">
                        <label class="col-form-label col-form-label-sm">Deudor</label>
                        <ng-select
                        [items]="SPN3"
                        name="Cesion"
                        class="custom"
                        [virtualScroll]="true"
                        loadingText="Cargando por favor espere..."
                        placeholder="Selecciona"
                        notFoundText="No hay coincidencias"
                        clearAllText="Limpiar todo"
                        >
                        </ng-select>
                        <!-- <div *ngIf="validator(debtor, cpForm)">
                            <span *ngIf="debtor.errors?.required">Requerido</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <!-- <div class="form-group" [ngClass]="{ 'text-danger': validator(debtor, cpForm) }"> -->
                        <div class="form-group">
                        <label class="col-form-label col-form-label-sm">Tipo de persona</label>
                        <ng-select
                        [items]="tp"
                        bindValue="valueId"
                        bindLabel="name"
                        name="debtor"
                        class="custom"
                        [virtualScroll]="true"
                        [loading]="loadValues"
                        loadingText="Cargando por favor espere..."
                        placeholder="Selecciona"
                        notFoundText="No hay coincidencias"
                        clearAllText="Limpiar todo"
                        [(ngModel)]="paymentCapacity.roleId"
                        >
                        </ng-select>
                        <!-- <div *ngIf="validator(debtor, cpForm)">
                            <span *ngIf="debtor.errors?.required">Requerido</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <!-- <div class="form-group" [ngClass]="{ 'text-danger': validator(aName, cpForm) }"> -->
                    <div class="form-group">
                        <label class="col-form-label col-form-label-sm">Contrato</label>
                        <!-- <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="paymentCapacity.applicant.name"
                        name="contrato"
                        #contrato="ngModel"
                        > -->
                        <input
                        type="text"
                        class="form-control form-control-sm"
                        >
                        <!-- <div *ngIf="validator(aName, cpForm)">
                            <span *ngIf="contrato.errors?.required">Requerido</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <!-- <div class="form-group" [ngClass]="{ 'text-danger': validator(transac, cpForm) }"> -->
                        <div class="form-group">
                        <label class="col-form-label col-form-label-sm">Cupo</label>
                        <ng-select
                        [items]="__cupo__"
                        name="transac"
                        class="custom"
                        [virtualScroll]="true"
                        loadingText="Cargando por favor espere..."
                        placeholder="Selecciona"
                        notFoundText="No hay coincidencias"
                        clearAllText="Limpiar todo"
                        >
                        </ng-select>
                        <!-- <div *ngIf="validator(transac, cpForm)">
                            <span *ngIf="transac.errors?.required">Requerido</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <!-- <div class="form-group" [ngClass]="{ 'text-danger': validator(aName, cpForm) }"> -->
                    <div class="form-group">
                        <label class="col-form-label col-form-label-sm" style="opacity: 0;">Cupo</label>
                        <!-- <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="paymentCapacity.applicant.name"
                        name="contrato"
                        #contrato="ngModel"
                        > -->
                        <input
                        type="text"
                        class="form-control form-control-sm"
                        >
                        <!-- <div *ngIf="validator(aName, cpForm)">
                            <span *ngIf="contrato.errors?.required">Requerido</span>
                        </div> -->
                    </div>
                </div>
            </div>
            <div id="accordion" role="tablist">
                <div class="card">
                    <div class="card-header" role="tab" id="tituloSolicitante" data-toggle="collapse"
                        data-target="#infoSolicitante" aria-expanded="false" aria-controls="infoSolicitante">
                        <h6 class="mb-0">Información del solicitante</h6>
                    </div>
                    <div id="infoSolicitante" class="card-body collapse show" role="tabpanel"
                        aria-labelledby="tituloSolicitante">
                        <!-- Fila 1 -->
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(aName, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Nombre completo</label>
                                    <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="paymentCapacity.applicant.name"
                                    name="aName"
                                    #aName="ngModel"
                                    >
                                    <div *ngIf="validator(aName, cpForm)">
                                        <span *ngIf="aName.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(lastName, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Apellido</label>
                                    <input
                                    type="text"
                                    class="form-control
                                    form-control-sm"
                                    name="lastName"
                                    [(ngModel)]="paymentCapacity.applicant.lastName"
                                    #lastName="ngModel"
                                    >
                                    <div *ngIf="validator(lastName, cpForm)">
                                        <span *ngIf="lastName.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': validator(typeOfIdentity, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Tipo de documento</label>
                                    <ng-select
                                    [items]="td" bindValue="valueId" bindLabel="name" class="custom"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..."
                                        [clearable]="false" [searchable]="false" name="typeOfIdentity"
                                        [(ngModel)]="paymentCapacity.applicant.typeOfIdentity"
                                        #typeOfIdentity="ngModel">
                                    </ng-select>
                                    <div *ngIf="validator(typeOfIdentity, cpForm)">
                                        <span *ngIf="typeOfIdentity.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': validator(documentNumber, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">No. identificación</label>
                                    <input type="text" class="form-control form-control-sm"
                                        [(ngModel)]="paymentCapacity.applicant.documentNumber" name="documentNumber"
                                        #documentNumber="ngModel">
                                    <div *ngIf="validator(documentNumber, cpForm)">
                                        <span *ngIf="documentNumber.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Fila 2 -->
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <span>&nbsp;</span>
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': validator(expeditionDate, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Fecha de expedición</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control form-control-sm text-center"
                                            ngbDatepicker #d2="ngbDatepicker" (click)="d2.toggle()"
                                            placeholder="Día/Mes/Año" [maxDate]="hoy" readonly name="expeditionDate"
                                            [(ngModel)]="paymentCapacity.applicant.expDate" #expeditionDate="ngModel">
                                        <button class="btn btn-info btn-sm" (click)="d2.toggle()" type="button"><i
                                                class="fa fa-calendar"></i></button>
                                    </div>
                                    <div *ngIf="validator(expeditionDate, cpForm)">
                                        <span *ngIf="expeditionDate.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4">
                                <span class="w-100 justify-content-center">Lugar de expedición</span>
                                <label class="col-form-label col-form-label-sm row">
                                    <div class="form-group col" [ngClass]="{ 'text-danger': validator(depart, cpForm) }">
                                        <label class="col-form-label col-form-label-sm">Departamento</label>
                                        <ng-select
                                            (change)="c1 = $event ? $event.cities : null; city = null; location = null"
                                            [items]="d" name="depart" bindValue="valueId" bindLabel="name" class="custom"
                                            [virtualScroll]="true" [loading]="loadValues" placeholder="Selecciona"
                                            loadingText="Cargando por favor espere..." clearAllText="Limpiar todo"
                                            notFoundText="No hay coincidencias" [(ngModel)]="department" #depart="ngModel">
                                        </ng-select>
                                        <div *ngIf="validator(depart, cpForm)">
                                            <span *ngIf="depart.errors.required">Requerido</span>
                                        </div>
                                    </div>
                                    <div class="form-group col" [ngClass]="{ 'text-danger': validator(cit, cpForm) }">
                                        <label class="col-form-label col-form-label-sm">Ciudad</label>
                                        <ng-select
                                            (change)="l1 = $event ? $event.localities : null; assignCity(); location = null"
                                            [items]="c1" bindValue="valueId" bindLabel="name" class="custom"
                                            [virtualScroll]="true" [readonly]="!depart.value" [loading]="loadValues"
                                            name="cit" loadingText="Cargando por favor espere..." placeholder="Selecciona"
                                            [(ngModel)]="city" notFoundText="No hay coincidencias"
                                            clearAllText="Limpiar todo" #cit="ngModel">
                                        </ng-select>
                                        <div *ngIf="validator(cit, cpForm)">
                                            <span *ngIf="cit.errors.required">Requerido</span>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-2">
                                <span>&nbsp;</span>
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(sex, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Género</label>
                                    <ng-select [items]="s" bindValue="valueId" bindLabel="name" class="custom"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..."
                                        [clearable]="false" [searchable]="false" name="sex"
                                        [(ngModel)]="paymentCapacity.applicant.sexId" #sex="ngModel">
                                    </ng-select>
                                    <div *ngIf="validator(sex, cpForm)">
                                        <span *ngIf="sex.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <span>&nbsp;</span>

                                <div class="form-group" [ngClass]="{ 'text-danger': validator(dateOfBirth, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Fecha de nacimiento</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control form-control-sm text-center"
                                            ngbDatepicker #d3="ngbDatepicker" (click)="d3.toggle()"
                                            placeholder="Día/Mes/Año" [maxDate]="hoy18" readonly name="dateOfBirth"
                                            [(ngModel)]="paymentCapacity.applicant.dateOfBirth" #dateOfBirth="ngModel">
                                        <button class="btn btn-info btn-sm" (click)="d3.toggle()" type="button"><i
                                                class="fa fa-calendar"></i></button>
                                    </div>
                                    <div *ngIf="validator(dateOfBirth, cpForm)">
                                        <span *ngIf="dateOfBirth.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Fila 3 -->
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(nationality, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Nacionalidad</label>
                                    <ng-select
                                    [items]="s"
                                    bindValue="valueId"
                                    bindLabel="name"
                                    class="custom"
                                    [loading]="loadValues"
                                    loadingText="Cargando por favor espere..."
                                    [clearable]="false"
                                    [searchable]="false"
                                    name="nationality"
                                    [(ngModel)]="paymentCapacity.applicant.nacionality"
                                    #nationality="ngModel"
                                    >
                                    </ng-select>
                                        <div *ngIf="validator(nationality, cpForm)">
                                        <span *ngIf="nationality.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(civilStatus, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Estado civil</label>
                                    <ng-select [items]="ec" bindValue="valueId" bindLabel="name" class="custom"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..."
                                        name="civilStatus" placeholder="Selecciona" [clearable]="false"
                                        [searchable]="false" [(ngModel)]="paymentCapacity.applicant.civilStatusId"
                                        #civilStatus="ngModel">
                                    </ng-select>
                                    <div *ngIf="validator(civilStatus, cpForm)">
                                        <span *ngIf="civilStatus.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(academicLevel, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Nivel académico</label>
                                    <ng-select [items]="na" bindValue="valueId" bindLabel="name" class="custom"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..."
                                        placeholder="Selecciona" [clearable]="false" [searchable]="false"
                                        [(ngModel)]="paymentCapacity.applicant.academicLevelId" name="academicLevel"
                                        #academicLevel="ngModel">
                                    </ng-select>
                                    <div *ngIf="validator(academicLevel, cpForm)">
                                        <span *ngIf="academicLevel.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(profession, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Profesión</label>
                                    <ng-select
                                    class="custom"
                                    loadingText="Cargando por favor espere..."
                                    placeholder="Selecciona"
                                    [(ngModel)]="paymentCapacity.applicant.profession"
                                    name="paymentCapacity"
                                    #profession="ngModel">
                                    </ng-select>

                                        <div *ngIf="validator(profession, cpForm)">
                                        <span *ngIf="profession.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Fila 4 -->
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group row"
                                    [ngClass]="{ 'text-danger': validator(minorLoad, cpForm) || validator(higherLoad, cpForm) }">
                                    <label class="col-12 col-form-label col-form-label-sm">
                                        Número de personas a cargo
                                    </label>
                                    <div class="col-6">
                                            <ng-select
                                            class="custom"
                                            loadingText="Cargando por favor espere..."
                                            placeholder="menor de 18"
                                            [(ngModel)]="paymentCapacity.applicant.dependentsOver18"
                                            nname="minorLoad"
                                            #minorLoad="ngModel">
                                            </ng-select>
                                    </div>
                                    <div class="col-6">
                                            <ng-select
                                            class="custom"
                                            loadingText="Cargando por favor espere..."
                                            placeholder="mayor de 18"
                                            [(ngModel)]="paymentCapacity.applicant.dependentsUnder18"
                                            name="highterLoad"
                                            #higherLoad="ngModel">
                                            </ng-select>
                                    </div>
                                    <div class="col-12" *ngIf="validator(minorLoad, cpForm)">
                                        <span *ngIf="minorLoad.errors?.min">Menor a 18 no puede ser negativo</span>
                                    </div>
                                    <div class="col-12" *ngIf="validator(higherLoad, cpForm)">
                                        <span *ngIf="higherLoad.errors?.min">Mayor a 18 no puede ser negativo</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(housing, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Tipo de vivienda</label>
                                    <ng-select [items]="tv" bindValue="valueId" bindLabel="name" class="custom"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..."
                                        [clearable]="false" [searchable]="false" name="housing"
                                        [(ngModel)]="paymentCapacity.applicant.housingTypeId" #housing="ngModel">
                                    </ng-select>
                                    <div *ngIf="validator(housing, cpForm)">
                                        <span *ngIf="housing.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(rent, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Declara renta</label>
                                    <ng-select class="custom" [loading]="loadValues"
                                        loadingText="Cargando por favor espere..." [clearable]="false"
                                        [searchable]="false" [(ngModel)]="paymentCapacity.applicant.declareRent"
                                        name="rent" #rent="ngModel">
                                        <ng-option value="Si">Si</ng-option>
                                        <ng-option value="No">No</ng-option>
                                    </ng-select>
                                    <div *ngIf="validator(rent, cpForm)">
                                        <span *ngIf="rent.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(address, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Dirección de residencia</label>
                                    <input type="text" class="form-control form-control-sm" name="address"
                                        [(ngModel)]="paymentCapacity.applicant.address" #address="ngModel">
                                    <div *ngIf="validator(address, cpForm)">
                                        <span *ngIf="address.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Fila 5 -->
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-2">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(countrym, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">País</label>
                                    <input type="text" class="form-control form-control-sm" name="countrym"
                                        [(ngModel)]="country" readonly #countrym="ngModel">
                                    <div *ngIf="validator(countrym, cpForm)">
                                        <span *ngIf="countrym.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-2">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(depart, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Departamento</label>
                                    <ng-select
                                        (change)="c1 = $event ? $event.cities : null; city = null; location = null"
                                        [items]="d" name="depart" bindValue="valueId" bindLabel="name" class="custom"
                                        [virtualScroll]="true" [loading]="loadValues" placeholder="Selecciona"
                                        loadingText="Cargando por favor espere..." clearAllText="Limpiar todo"
                                        notFoundText="No hay coincidencias" [(ngModel)]="department" #depart="ngModel">
                                    </ng-select>
                                    <div *ngIf="validator(depart, cpForm)">
                                        <span *ngIf="depart.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-2">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(cit, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Ciudad</label>
                                    <ng-select
                                        (change)="l1 = $event ? $event.localities : null; assignCity(); location = null"
                                        [items]="c1" bindValue="valueId" bindLabel="name" class="custom"
                                        [virtualScroll]="true" [readonly]="!depart.value" [loading]="loadValues"
                                        name="cit" loadingText="Cargando por favor espere..." placeholder="Selecciona"
                                        [(ngModel)]="city" notFoundText="No hay coincidencias"
                                        clearAllText="Limpiar todo" #cit="ngModel">
                                    </ng-select>
                                    <div *ngIf="validator(cit, cpForm)">
                                        <span *ngIf="cit.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-sm-12 col-md-6 col-lg-2">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(loc, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Localidad</label>
                                    <ng-select [items]="l1" (change)="assignCity()" bindValue="valueId" bindLabel="name"
                                        class="custom" [virtualScroll]="true" [readonly]="!cit.value || l1.length === 0"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..."
                                        placeholder="Selecciona" notFoundText="No hay coincidencias" name="loc"
                                        clearAllText="Limpiar todo" [(ngModel)]="location" #loc="ngModel">
                                    </ng-select>
                                    <div *ngIf="validator(loc, cpForm)">
                                        <span *ngIf="loc.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div> -->
                            <div class="col-sm-12 col-md-6 col-lg-2">
                                <div class="form-group" [ngClass]="{ 'text-danger': validator(stratum, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Estrato</label>
                                    <ng-select [items]="ese" bindValue="valueId" bindLabel="name" class="custom"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..." name="stratum"
                                        placeholder="Selecciona" [clearable]="false" [searchable]="false"
                                        [(ngModel)]="paymentCapacity.applicant.stratumSEId" #stratum="ngModel">
                                    </ng-select>
                                    <div *ngIf="validator(stratum, cpForm)">
                                        <span *ngIf="stratum.errors?.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-2">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': validator(yearsResidence, cpForm) }">
                                    <label class="col-form-label col-form-label-sm">Años en la residencia</label>
                                    <ng-select
                                    class="custom"
                                    [(ngModel)]="paymentCapacity.applicant.yearsInResidence"
                                    name="yearsResidence"
                                    #yearsResidence="ngModel"
                                    placeholder="Selecciona"
                                    >
                                    </ng-select>
                                    <div *ngIf="validator(yearsResidence, cpForm)">
                                        <span *ngIf="yearsResidence.errors.required">Requerido</span>
                                        <span *ngIf="yearsResidence.errors.min">No puede ser negativo</span>
                                        <span *ngIf="yearsResidence.errors.pattern">Solo números</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Fila 6 -->
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-2">
                                <div class="form-group" [ngClass]="{ 'text-danger': phone.invalid && phone.touched }">
                                    <label class="col-form-label col-form-label-sm">Teléfono</label>
                                    <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####"
                                        [imask]="phoneMask" [unmask]="true" name="phone" [unmask]="'typed'"
                                        [(ngModel)]="paymentCapacity.applicant.phone" #phone="ngModel">
                                    <div *ngIf="phone.errors && (phone.dirty || phone.touched)">
                                        <span *ngIf="phone.errors.required">Requerido</span>
                                        <span *ngIf="phone.errors.minlength">Complete los digitos</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-2">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': cellular.invalid && cellular.touched }">
                                    <label class="col-form-label col-form-label-sm">Celular</label>
                                    <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####"
                                        name="cellular" [imask]="cellularMask" [unmask]="'typed'"
                                        [(ngModel)]="paymentCapacity.applicant.cellPhone" #cellular="ngModel">
                                    <div *ngIf="cellular.errors && (cellular.dirty || cellular.touched)">
                                        <span *ngIf="cellular.errors.required">Requerido</span>
                                        <span *ngIf="cellular.errors.minlength">Complete los digitos</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4">
                                <div class="form-group" [ngClass]="{ 'text-danger': email.invalid && email.touched }">
                                    <label class="col-form-label col-form-label-sm">Email<strong> *</strong></label>
                                    <input type="text" class="form-control form-control-sm"
                                        [(ngModel)]="paymentCapacity.applicant.email" name="email"
                                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" #email="ngModel">
                                    <div *ngIf="email.errors && (email.dirty || email.touched)">
                                        <span *ngIf="email.errors.required">Requerido</span>
                                        <span *ngIf="email.errors.pattern">Formato email incorrecto</span>
                                        <!-- <span *ngIf="email.errors.existEmail">El email ya esta en uso</span> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 info">
                                <sub><strong>*</strong> Autorizo el envio de mi extracto e información relacionada con
                                    el Plan a la dirección eletrónica por mi informada.</sub>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="paymentCapacity.spouse">
                    <div class="card-header" role="tab" id="tituloConyuge" data-toggle="collapse"
                        data-target="#infoConyuge" aria-expanded="false" aria-controls="infoConyuge">
                        <h6 class="mb-0">Datos del Conyuge</h6>
                    </div>
                    <div id="infoConyuge" class="card-body collapse show" role="tabpanel"
                        aria-labelledby="tituloConyuge">
                        <!-- Fila 1 -->
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group" [ngClass]="{ 'text-danger': name1.invalid && name1.touched }">
                                    <label class="col-form-label col-form-label-sm">Nombre completo</label>
                                    <input type="text" class="form-control form-control-sm" name="name1"
                                        [(ngModel)]="paymentCapacity.spouse.name" #name1="ngModel">
                                    <div *ngIf="name1.errors && (name1.dirty || name1.touched)">
                                        <span *ngIf="name1.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': lastName1.invalid && lastName1.touched }">
                                    <label class="col-form-label col-form-label-sm">Apellido</label>
                                    <input type="text" class="form-control form-control-sm" name="lastName1"
                                        [(ngModel)]="paymentCapacity.spouse.lastName" #lastName1="ngModel">
                                    <div *ngIf="lastName1.errors && (lastName1.dirty || lastName1.touched)">
                                        <span *ngIf="lastName1.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': typeOfIdentity1.invalid && typeOfIdentity1.touched }">
                                    <label class="col-form-label col-form-label-sm">Tipo de documento</label>
                                    <ng-select [items]="td" bindValue="valueId" bindLabel="name" class="custom"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..."
                                        [clearable]="false" [searchable]="false" name="typeOfIdentity1"
                                        [(ngModel)]="paymentCapacity.spouse.typeOfIdentity" #typeOfIdentity1="ngModel">
                                    </ng-select>
                                    <div
                                        *ngIf="typeOfIdentity1.errors && (typeOfIdentity1.dirty || typeOfIdentity1.touched)">
                                        <span *ngIf="typeOfIdentity1.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': documentNumber1.invalid && documentNumber1.touched }">
                                    <label class="col-form-label col-form-label-sm">No. identificación</label>
                                    <input type="text" class="form-control form-control-sm" name="documentNumber1"
                                        [(ngModel)]="paymentCapacity.spouse.documentNumber" #documentNumber1="ngModel">
                                    <div
                                        *ngIf="documentNumber1.errors && (documentNumber1.dirty || documentNumber1.touched)">
                                        <span *ngIf="documentNumber1.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Fila 2 -->
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group text-center"
                                    [ngClass]="{ 'text-danger': dateOfBirth1.invalid && dateOfBirth1.touched }">
                                    <label class="col-form-label col-form-label-sm">Fecha de nacimiento</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control form-control-sm text-center"
                                            ngbDatepicker #d4="ngbDatepicker" (click)="d4.toggle()"
                                            placeholder="Día/Mes/Año" [maxDate]="hoy18" readonly name="dateOfBirth1"
                                            [(ngModel)]="paymentCapacity.spouse.dateOfBirth" #dateOfBirth1="ngModel">
                                        <button class="btn btn-info btn-sm" (click)="d4.toggle()" type="button"><i
                                                class="fa fa-calendar"></i></button>
                                    </div>
                                    <div *ngIf="dateOfBirth1.errors && (dateOfBirth1.dirty || dateOfBirth1.touched)">
                                        <span *ngIf="dateOfBirth1.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group" [ngClass]="{ 'text-danger': sex1.invalid && sex1.touched }">
                                    <label class="col-form-label col-form-label-sm">Género</label>
                                    <ng-select [items]="s" bindValue="valueId" bindLabel="name" class="custom"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..."
                                        [clearable]="false" [searchable]="false" name="sex1"
                                        [(ngModel)]="paymentCapacity.spouse.sexId" #sex1="ngModel">
                                    </ng-select>
                                    <div *ngIf="sex1.errors && (sex1.dirty || sex1.touched)">
                                        <span *ngIf="sex1.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': chevyPlan1.invalid && chevyPlan1.touched }">
                                    <label class="col-form-label col-form-label-sm info1 mb-1">Tiene relación con
                                        ChevyPlan, GM, Concesionario?</label>
                                    <ng-select class="custom" [loading]="loadValues" name="cheviPlan1"
                                        loadingText="Cargando por favor espere..." [clearable]="false"
                                        [searchable]="false" [(ngModel)]="paymentCapacity.spouse.relationship"
                                        #chevyPlan1="ngModel">
                                        <ng-option value="Si">Si</ng-option>
                                        <ng-option value="No">No</ng-option>
                                    </ng-select>
                                    <div *ngIf="chevyPlan1.errors && (chevyPlan1.dirty || chevyPlan1.touched)">
                                        <span *ngIf="chevyPlan1.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': address1.invalid && address1.touched }">
                                    <label class="col-form-label col-form-label-sm">Dirección de residencia</label>
                                    <input type="text" class="form-control form-control-sm" name="address1"
                                        [(ngModel)]="paymentCapacity.spouse.address" #address1="ngModel">
                                    <div *ngIf="address1.errors && (address1.dirty || address1.touched)">
                                        <span *ngIf="address1.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Fila 3 -->
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-4">
                                <span class="w-100 justify-content-center">Lugar de expedición</span>
                                <label class="col-form-label col-form-label-sm row">
                                    <div class="form-group col" [ngClass]="{ 'text-danger': validator(depart, cpForm) }">
                                        <label class="col-form-label col-form-label-sm">Departamento</label>
                                        <ng-select
                                        name="conyuge_depart"
                                        bindValue="valueId"
                                        bindLabel="name"
                                        class="custom"
                                        [virtualScroll]="true"
                                        [loading]="loadValues"
                                        placeholder="Selecciona"
                                        loadingText="Cargando por favor espere..."
                                        clearAllText="Limpiar todo"
                                        notFoundText="No hay coincidencias">
                                        </ng-select>
                                        <div *ngIf="validator(depart, cpForm)">
                                            <span *ngIf="depart.errors.required">Requerido</span>
                                        </div>
                                    </div>
                                    <div class="form-group col" [ngClass]="{ 'text-danger': validator(cit, cpForm) }">
                                        <label class="col-form-label col-form-label-sm">Ciudad</label>
                                        <ng-select
                                        name="conyuge_ciudad"
                                        bindValue="valueId"
                                        bindLabel="name"
                                        class="custom"
                                        [virtualScroll]="true"
                                        [loading]="loadValues"
                                        placeholder="Selecciona"
                                        loadingText="Cargando por favor espere..."
                                        clearAllText="Limpiar todo"
                                        notFoundText="No hay coincidencias">
                                        </ng-select>
                                        <div *ngIf="validator(cit, cpForm)">
                                            <span *ngIf="cit.errors.required">Requerido</span>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <!-- <div class="col-sm-12 col-md-6 col-lg-2"> -->
                                <!-- <div class="form-group"
                                    [ngClass]="{ 'text-danger': location1.invalid && location1.touched }">
                                    <label class="col-form-label col-form-label-sm">Localidad</label>
                                    <ng-select [items]="l2" bindValue="valueId" bindLabel="name" class="custom"
                                        [virtualScroll]="true" [readonly]="!city1.value || l2.length === 0"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..." name="location1"
                                        placeholder="Selecciona" notFoundText="No hay coincidencias" name="location1"
                                        clearAllText="Limpiar todo" #location1="ngModel">
                                    </ng-select>
                                    <div *ngIf="location1.errors && (location1.dirty || location1.touched)">
                                        <span *ngIf="location1.errors.required">Requerido</span>
                                    </div>
                                </div> -->
                            <!-- </div> -->
                            <div class="col-sm-12 col-md-6 col-lg-2">
                                <span class="w-100 justify-content-center">Lugar de expedición</span>
                                <div class="form-group" [ngClass]="{ 'text-danger': phone1.invalid && phone1.touched }">
                                    <label class="col-form-label col-form-label-sm">Teléfono/Celular</label>
                                    <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####"
                                        [imask]="phoneMask" [unmask]="'typed'"
                                        [(ngModel)]="paymentCapacity.spouse.phone" name="phone1" #phone1="ngModel">
                                    <div *ngIf="phone1.errors && (phone1.dirty || phone1.touched)">
                                        <span *ngIf="phone1.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4">
                                <span class="w-100 justify-content-center">Lugar de expedición</span>
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': activities1.invalid && activities1.touched }">
                                    <label class="col-form-label col-form-label-sm">Actividad</label>
                                    <input type="text" class="form-control form-control-sm" [imask]="nameMask"
                                    [(ngModel)]="paymentCapacity.spouse.spounseEconomicActivity" #activities1="ngModel">
                                    <!-- <ng-select [items]="act" bindValue="valueId" bindLabel="name" class="custom"
                                        [virtualScroll]="true" [loading]="loadValues" name="activities1"
                                        loadingText="Cargando por favor espere..." placeholder="Selecciona"
                                        notFoundText="No hay coincidencias" clearAllText="Limpiar todo"
                                        [(ngModel)]="paymentCapacity.spouse.economicActivityId" #activities1="ngModel">
                                    </ng-select> -->
                                    <div *ngIf="activities1.errors && (activities1.dirty || activities1.touched)">
                                        <span *ngIf="activities1.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" role="tab" id="tituloActividad" data-toggle="collapse"
                        data-target="#infoActividad" aria-expanded="false" aria-controls="infoActividad">
                        <h6 class="mb-0">Actividad económica principal del solicitante</h6>
                    </div>
                    <div id="infoActividad" class="card-body collapse show" role="tabpanel"
                        aria-labelledby="tituloActividad">
                        <!-- Fila 1 -->
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-2">
                                <div class="form-group">
                                    <label class="col-form-label col-form-label-sm">Código CIIU</label>
                                    <ng-select
                                    class="custom"
                                    placeholder="Selecciona"
                                    name="ciiu"
                                    [(ngModel)]="paymentCapacity.ecoActivApplicant.ciiuCode"
                                    #ciiu="ngModel"
                                    >
                                    </ng-select>
                                    <div *ngIf="ciiu.errors && (ciiu.dirty || ciiu.touched)">
                                        <span *ngIf="ciiu.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 row ">
                                <div class="form-group col" [ngClass]="{ 'text-danger': job.invalid && job.touched }">
                                    <label class="col-form-label col-form-label-sm">Empleo</label>
                                    <ng-select [items]="emp" bindValue="valueId" bindLabel="name" class="custom"
                                        [virtualScroll]="true" [loading]="loadValues" name="job"
                                        [(ngModel)]="paymentCapacity.ecoActivApplicant.jobId"
                                        loadingText="Cargando por favor espere..." placeholder="Selecciona"
                                        notFoundText="No hay coincidencias" clearAllText="Limpiar todo" #job="ngModel">
                                    </ng-select>
                                    <div *ngIf="job.errors && (job.dirty || job.touched)">
                                        <span *ngIf="job.errors.required">Requerido</span>
                                    </div>
                                </div>
                                <div class="form-group col">
                                    <label class="col-form-label col-form-label-sm">¿Cuál?</label>
                                    <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    name="empleo_intput">
                                    <!-- #empleo_intput="ngModel"
                                    >-->
                                    <!-- <div *ngIf="phone1.errors && (phone1.dirty || phone1.touched)">
                                        <span *ngIf="phone1.errors.required">Requerido</span>
                                    </div> -->
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6" *ngIf="job.value === '7'">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': whichJob.invalid && whichJob.touched }">
                                    <label class="col-form-label col-form-label-sm">¿Cuál?</label>
                                    <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    [readonly]="job.value !== '7'"
                                    name="whichJob"
                                    [(ngModel)]="paymentCapacity.ecoActivApplicant.whichJob"
                                    #whichJob="ngModel"
                                    >
                                    <div *ngIf="whichJob.errors && (whichJob.dirty || whichJob.touched)">
                                        <span *ngIf="whichJob.errors.required">Indique cuál</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-2" *ngIf="job.value !== '7'">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': business.invalid && business.touched }">
                                    <label class="col-form-label col-form-label-sm">Nombre de la empresa/negocio</label>
                                    <input type="text" class="form-control form-control-sm" name="business"
                                        [(ngModel)]="paymentCapacity.ecoActivApplicant.companyName" #business="ngModel">
                                    <div *ngIf="business.errors && (business.dirty || business.touched)">
                                        <span *ngIf="business.errors.required">Requedido</span>
                                    </div>
                                </div>
                            </div>
                            <!-- arreglar esto -->
                            <!--  *ngIf="business.value" -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': antiquity.invalid && antiquity.touched }">
                                    <label class="col-form-label col-form-label-sm">Antiguedad</label>
                                    <ng-select
                                    class="custom"
                                    name="antiquity"
                                    [(ngModel)]="paymentCapacity.ecoActivApplicant.antiquity"
                                    [ngModelOptions]="{standalone: true}"
                                    #antiquity="ngModel"></ng-select>
                                    <div *ngIf="antiquity.errors && (antiquity.dirty || antiquity.touched)">
                                        <span *ngIf="antiquity.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <!--  *ngIf="business.value" -->
                            <div class="col-sm-12 col-md-4 col-lg-2">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': position.invalid && position.touched }">
                                    <label class="col-form-label col-form-label-sm">Cargo</label>
                                    <ng-select
                                    class="custom"
                                    name="position"
                                        [(ngModel)]="paymentCapacity.ecoActivApplicant.position" #position="ngModel">
                                    </ng-select>
                                    <div *ngIf="position.errors && (position.dirty || position.touched)">
                                        <span *ngIf="position.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Fila 2 -->
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': chevyPlan.invalid && chevyPlan.touched }">
                                    <label class="col-form-label col-form-label-sm info1 mb-1">Tiene relación con
                                        ChevyPlan, GM, Concesionario?</label>
                                    <ng-select class="custom" [loading]="loadValues"
                                        loadingText="Cargando por favor espere..." [clearable]="false"
                                        [searchable]="false" name="chevyPlan"
                                        [(ngModel)]="paymentCapacity.ecoActivApplicant.relationship"
                                        #chevyPlan="ngModel">
                                        <ng-option value="Si">Si</ng-option>
                                        <ng-option value="No">No</ng-option>
                                    </ng-select>
                                    <div *ngIf="chevyPlan.errors && (chevyPlan.dirty || chevyPlan.touched)">
                                        <span *ngIf="chevyPlan.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': contract.invalid && contract.touched }">
                                    <label class="col-form-label col-form-label-sm">Tipo de contrato</label>
                                    <ng-select [items]="tc" bindValue="valueId" bindLabel="name" class="custom"
                                        name="contract" [loading]="loadValues"
                                        loadingText="Cargando por favor espere..." placeholder="Selecciona"
                                        [clearable]="false" [searchable]="false"
                                        [(ngModel)]="paymentCapacity.ecoActivApplicant.contractId" #contract="ngModel">
                                    </ng-select>
                                    <div *ngIf="contract.errors && (contract.dirty || contract.touched)">
                                        <span *ngIf="contract.errors.required">Requerido</span>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-sm-12 col-md-6 col-lg-6" *ngIf="contract.value === '4'"> -->
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <div class="form-group"
                                    [ngClass]="{ 'text-danger': whichContract.invalid && whichContract.touched }">
                                    <label class="col-form-label col-form-label-sm">¿Cuál?</label>
                                    <input type="text" class="form-control form-control-sm"
                                        [(ngModel)]="paymentCapacity.ecoActivApplicant.whichContract"
                                        name="wichContract" [readonly]="contract.value !== '4'"
                                        #whichContract="ngModel">
                                    <div *ngIf="whichContract.errors && (whichContract.dirty || whichContract.touched)">
                                        <span *ngIf="whichContract.errors.required">Indique cuál</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3">
                                <!-- <div class="form-group" [ngClass]="{ 'text-danger': address2.invalid && address2.touched }">
                                    <label class="col-form-label col-form-label-sm">Dirección</label>
                                    <input name="address2" type="text" class="form-control form-control-sm" #address2="ngModel">
                                    <div *ngIf="address2.errors && (address2.dirty || address2.touched)">
                                        <span *ngIf="address2.errors.required">Requerido</span>
                                    </div>
                                </div> -->
                                <div class="form-group">
                                    <label class="col-form-label col-form-label-sm">Dirección</label>
                                    <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    name="ecoActivApplicant_direccion"
                                    [(ngModel)]="paymentCapacity.ecoActivApplicant.address"
                                    #ecoActivApplicant_direccion
                                    >
                                    <div *ngIf="ecoActivApplicant_direccion.errors && (ecoActivApplicant_direccion.dirty || ecoActivApplicant_direccion.touched)">
                                        <span *ngIf="ecoActivApplicant_direccion.errors.required">Indique cuál</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Fila 3 -->
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-2">
                                <!-- <div class="form-group"
                                    [ngClass]="{ 'text-danger': department2.invalid && department2.touched }">
                                    <label class="col-form-label col-form-label-sm">Departamento</label>
                                    <ng-select (change)="c3 = $event ? $event.cities : null" [items]="d"
                                        bindValue="valueId" bindLabel="name" class="custom" [virtualScroll]="true"
                                        name="department2" [loading]="loadValues" loadingText="Cargando por favor espere..."
                                        placeholder="Selecciona" notFoundText="No hay coincidencias"
                                        clearAllText="Limpiar todo" #department2="ngModel">
                                    </ng-select>
                                    <div *ngIf="department2.errors && (department2.dirty || department2.touched)">
                                        <span *ngIf="department2.errors.required">Requerido</span>
                                    </div>
                                </div> -->
                                <!-- <div class="form-group" [ngClass]="{ 'text-danger': department2.invalid && department2.touched }"> -->
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4">
                                <label class="col-form-label col-form-label-sm row">
                                    <div class="form-group col" [ngClass]="{ 'text-danger': validator(depart, cpForm) }">
                                        <label class="col-form-label col-form-label-sm">Departamento</label>
                                        <ng-select
                                            (change)="c3 = $event ? $event.cities : null; city = null; location = null"
                                            [items]="d" name="depart" bindValue="valueId" bindLabel="name" class="custom"
                                            [virtualScroll]="true" [loading]="loadValues" placeholder="Selecciona"
                                            loadingText="Cargando por favor espere..." clearAllText="Limpiar todo"
                                            notFoundText="No hay coincidencias" [(ngModel)]="department" #depart3="ngModel">
                                        </ng-select>
                                        <div *ngIf="validator(depart, cpForm)">
                                            <span *ngIf="depart.errors.required">Requerido</span>
                                        </div>
                                    </div>
                                    <div class="form-group col" [ngClass]="{ 'text-danger': validator(cit, cpForm) }">
                                        <label class="col-form-label col-form-label-sm">Ciudad</label>
                                        <ng-select
                                            (change)="l3 = $event ? $event.localities : null; assignCity(); location = null"
                                            [items]="c3" bindValue="valueId" bindLabel="name" class="custom"
                                            [virtualScroll]="true" [readonly]="!depart.value" [loading]="loadValues"
                                            name="cit" loadingText="Cargando por favor espere..." placeholder="Selecciona"
                                            [(ngModel)]="city" notFoundText="No hay coincidencias"
                                            clearAllText="Limpiar todo" #cit3="ngModel">
                                        </ng-select>
                                        <div *ngIf="validator(cit, cpForm)">
                                            <span *ngIf="cit.errors.required">Requerido</span>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-2">
                                <!-- <div class="form-group" [ngClass]="{ 'text-danger': city2.invalid && city2.touched }">
                                    <label class="col-form-label col-form-label-sm">Ciudad</label>
                                    <ng-select (change)="l3 = $event ? $event.localities : null" [items]="c3"
                                        bindValue="valueId" bindLabel="name" class="custom" [virtualScroll]="true"
                                        [readonly]="!department2.value" [loading]="loadValues" name="city2"
                                        loadingText="Cargando por favor espere..." placeholder="Selecciona"
                                        notFoundText="No hay coincidencias" clearAllText="Limpiar todo"
                                        #city2="ngModel">
                                    </ng-select>
                                    <div *ngIf="city2.errors && (city2.dirty || city2.touched)">
                                        <span *ngIf="city2.errors.required">Requerido</span>
                                    </div> -->
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <!-- <div class="form-group"
                                    [ngClass]="{ 'text-danger': location2.invalid && location2.touched }">
                                    <label class="col-form-label col-form-label-sm">Localidad</label>
                                    <ng-select [items]="l3" bindValue="valueId" bindLabel="name" class="custom"
                                        [virtualScroll]="true" [readonly]="!city2.value || l3.length === 0"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..."
                                        placeholder="Selecciona" notFoundText="No hay coincidencias" name="location2"
                                        clearAllText="Limpiar todo" #location2="ngModel">
                                    </ng-select>
                                    <div *ngIf="location2.errors && (location2.dirty || location2.touched)">
                                        <span *ngIf="location2.errors.required">Requerido</span>
                                    </div>
                                </div> -->
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4">
                            <div class="form-group" [ngClass]="{ 'text-danger': phone2.invalid && phone2.touched }">
                                <label class="col-form-label col-form-label-sm">Teléfonos</label>
                                <input
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="(###) ### ####"
                                name="phone2"
                                [imask]="phoneMask"
                                [unmask]="'typed'"
                                [(ngModel)]="paymentCapacity.ecoActivApplicant.phones" [ngModelOptions]="{standalone: true}"
                                #phone2="ngModel">
                                    <div *ngIf="phone2.errors && (phone2.dirty || phone2.touched)">
                                        <span *ngIf="phone2.errors.required">Requerido</span>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <!-- Fila 4 -->
                    <div class="row" *ngIf="job.value === '2'">
                        <div class="col-12 text-center">
                            <div class="alert alert-dark" role="alert">
                                <strong>Solo para independientes</strong>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': activities2.invalid && activities2.touched }">
                                <label class="col-form-label col-form-label-sm">Especfique su actividad</label>
                                <input type="text" class="form-control form-control-sm"
                                    [(ngModel)]="paymentCapacity.ecoActivApplicant.ecoActivIndependent"
                                    name="activities2" #activities2="ngModel">
                                <div *ngIf="activities2.errors && (activities2.dirty || activities2.touched)">
                                    <span *ngIf="activities2.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': composition.invalid && composition.touched }">
                                <label class="col-form-label col-form-label-sm">Composición</label>
                                <ng-select [items]="c" bindValue="valueId" bindLabel="name" class="custom"
                                    [loading]="loadValues" loadingText="Cargando por favor espere..."
                                    placeholder="Selecciona" [clearable]="false" [searchable]="false"
                                    [(ngModel)]="paymentCapacity.ecoActivApplicant.compositionId" name="composition"
                                    #composition="ngModel">
                                </ng-select>
                                <div *ngIf="composition.errors && (composition.dirty || composition.touched)">
                                    <span *ngIf="composition.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': sectorActivity.invalid && sectorActivity.touched }">
                                <label class="col-form-label col-form-label-sm">Sector actividad económica</label>
                                <ng-select [items]="sa" bindValue="valueId" bindLabel="name" class="custom"
                                    [virtualScroll]="true" [loading]="loadValues"
                                    loadingText="Cargando por favor espere..." placeholder="Selecciona"
                                    [clearable]="false" [searchable]="false" name="sectorActivity"
                                    [(ngModel)]="paymentCapacity.ecoActivApplicant.sectorId" #sectorActivity="ngModel">
                                </ng-select>
                                <div *ngIf="sectorActivity.errors && (sectorActivity.dirty || sectorActivity.touched)">
                                    <span *ngIf="sectorActivity.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-1">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': employees.invalid && employees.touched }">
                                <label class="col-form-label col-form-label-sm">
                                    <!-- No. e -->Empleados</label>
                                <input type="text" class="form-control form-control-sm" [imask]="numberIntMask"
                                    [unmask]="'typed'" [(ngModel)]="paymentCapacity.ecoActivApplicant.numEmployees"
                                    name="employees" #employees="ngModel">
                                <div *ngIf="employees.errors && (employees.dirty || employees.touched)">
                                    <span *ngIf="employees.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-2">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': participation.invalid && participation.touched }">
                                <label class="col-form-label col-form-label-sm">% participación
                                    <!--  en la empresa --> <i class="fa fa-info-circle"
                                        title="% de participación en la empresa"></i></label>
                                <input type="number" class="form-control form-control-sm text-right"
                                    [imask]="numberIntMask" name="participation" [unmask]="'typed'"
                                    [(ngModel)]="paymentCapacity.ecoActivApplicant.numPartCompany"
                                    #participation="ngModel">
                                <div *ngIf="participation.errors && (participation.dirty || participation.touched)">
                                    <span *ngIf="participation.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header" role="tab" id="tituloFinanciera" data-toggle="collapse"
                    data-target="#infoFinanciera" aria-expanded="false" aria-controls="infoFinanciera">
                    <h6 class="mb-0">Información financiera</h6>
                </div>
                <div id="infoFinanciera" class="card-body collapse show" role="tabpanel"
                    aria-labelledby="tituloFinanciera">
                    <!-- Fila 1 -->
                    <div class="row">
                        <div class="col-sm-6 col-md-3 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': monthlyIncome.invalid && monthlyIncome.touched }">
                                <label class="col-form-label col-form-label-sm">
                                    Ingresos mensuales
                                    <sup><strong>1</strong></sup>
                                </label>
                                <div class="input-group input-group-sm mb-auto">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">$</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" [imask]="currencyMask"
                                        [unmask]="'typed'" (change)="sumTotalIncome()" placeholder="0" name="monthlyIncome"
                                        [(ngModel)]="paymentCapacity.financialInfo.monthlyIncome" #monthlyIncome="ngModel">
                                </div>
                                <div *ngIf="monthlyIncome.errors && (monthlyIncome.dirty || monthlyIncome.touched)">
                                    <span *ngIf="monthlyIncome.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': otherIncome.invalid && otherIncome.touched }">
                                <label class="col-form-label col-form-label-sm">Otros ingresos mensuales </label>
                                <div class="input-group input-group-sm mb-auto">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">$</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" [imask]="currencyMask"
                                        [unmask]="'typed'" (change)="sumTotalIncome()" placeholder="0"
                                        [(ngModel)]="paymentCapacity.financialInfo.otherMonthlyIncome" name="otherIncome"
                                        #otherIncome="ngModel">
                                </div>
                                <div *ngIf="otherIncome.errors && (otherIncome.dirty || otherIncome.touched)">
                                    <span *ngIf="otherIncome.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': descriptionOtherIncome.invalid && descriptionOtherIncome.touched }">
                                <label class="col-form-label col-form-label-sm">
                                    Descripción de otros ingresos
                                </label>
                                <input type="text" class="form-control form-control-sm" [readonly]="!otherIncome.value"
                                    [(ngModel)]="paymentCapacity.financialInfo.descripOtherMI"
                                    name="descriptionOtherIncome" #descriptionOtherIncome="ngModel">
                                <div
                                    *ngIf="descriptionOtherIncome.errors && (descriptionOtherIncome.dirty || descriptionOtherIncome.touched)">
                                    <span *ngIf="descriptionOtherIncome.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': totalIncome.invalid && totalIncome.touched }">
                                <label class="col-form-label col-form-label-sm">Total ingresos</label>
                                <div class="input-group input-group-sm mb-auto">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">$</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" [imask]="currencyMask"
                                        [unmask]="'typed'" readonly placeholder="0" name="totalIncome"
                                        [(ngModel)]="paymentCapacity.financialInfo.totalIncome" #totalIncome="ngModel">
                                </div>
                                <div *ngIf="totalIncome.errors && (totalIncome.dirty || totalIncome.touched)">
                                    <span *ngIf="totalIncome.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Fila 2 -->
                    <div class="row">
                        <div class="col-sm-6 col-md-3 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': totalExpenses.invalid && totalExpenses.touched }">
                                <label class="col-form-label col-form-label-sm">Total egresos mensuales</label>
                                <div class="input-group input-group-sm mb-auto">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">$</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" [imask]="currencyMask"
                                        [unmask]="'typed'" (change)="sumTotalLiabilities()" placeholder="0"
                                        name="totalExpenses" [(ngModel)]="paymentCapacity.financialInfo.totalExpenses"
                                        #totalExpenses="ngModel">
                                </div>
                                <div *ngIf="totalExpenses.errors && (totalExpenses.dirty || totalExpenses.touched)">
                                    <span *ngIf="totalExpenses.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': totalAssets.invalid && totalAssets.touched }">
                                <label class="col-form-label col-form-label-sm">Total activos</label>
                                <div class="input-group input-group-sm mb-auto">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">$</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" [imask]="currencyMask"
                                        [unmask]="'typed'" (change)="sumTotalLiabilities()" placeholder="0"
                                        name="totalAssets" [(ngModel)]="paymentCapacity.financialInfo.totalAssets"
                                        #totalAssets="ngModel">
                                </div>
                                <div *ngIf="totalAssets.errors && (totalAssets.dirty || totalAssets.touched)">
                                    <span *ngIf="totalAssets.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': assetsDetail.invalid && assetsDetail.touched }">
                                <label class="col-form-label col-form-label-sm">Indique detalles de activos</label>
                                <ng-select [items]="a" bindValue="valueId" bindLabel="name" class="custom"
                                    [virtualScroll]="true" [readonly]="!totalAssets.value" [loading]="loadValues"
                                    loadingText="Cargando por favor espere..." placeholder="Selecciona"
                                    [clearable]="false" [searchable]="false" multiple="true" name="assetsDetail"
                                    [(ngModel)]="paymentCapacity.financialInfo.assetsDetail" #assetsDetail="ngModel">
                                </ng-select>
                                <div *ngIf="assetsDetail.errors && (assetsDetail.dirty || assetsDetail.touched)">
                                    <span *ngIf="assetsDetail.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': totalLiabilities.invalid && totalLiabilities.touched }">
                                <label class="col-form-label col-form-label-sm">Total pasivos</label>
                                <div class="input-group input-group-sm mb-auto">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">$</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" [imask]="currencyMask"
                                        [unmask]="'typed'" placeholder="0" name="totalLiabilities"
                                        [(ngModel)]="paymentCapacity.financialInfo.totalPassive"
                                        #totalLiabilities="ngModel">
                                </div>
                                <div
                                    *ngIf="totalLiabilities.errors && (totalLiabilities.dirty || totalLiabilities.touched)">
                                    <span *ngIf="totalLiabilities.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 info">
                            <sup><strong>1</strong></sup><sub> Ingresos mensuales de la actividad principal)</sub>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header" role="tab" id="tituloReferencias" data-toggle="collapse"
                    data-target="#infoReferencias" aria-expanded="false" aria-controls="infoReferencias">
                    <h6 class="mb-0">Información referencias</h6>
                </div>
                <div id="infoReferencias" class="card-body collapse show" role="tabpanel"
                    aria-labelledby="tituloReferencias">
                    <!-- Fila 2 -->
                    <div class="row">
                        <div class="col-sm-1">
                            <label class="col-form-label col-form-label-sm">&nbsp;</label><br>
                            <img src="assets/img/add.png" class="img-add" title="Agregar referencia"
                                (click)="addReference()">
                        </div>
                    </div>
                    <!-- Fila 3 -->
                    <div class="row">
                        <div class="col">
                            <table class="table table-hover text-center info">
                                <thead class="thead-light">
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Nombre</th>
                                        <th>Relación</th>
                                        <th>Dirección</th>
                                        <th>Ciudad</th>
                                        <th>Departamento</th>
                                        <th>Localidad</th>
                                        <th>Teléfono</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let x of paymentCapacity.references; let i = index">
                                        <td>
                                            <div class="form-group"
                                                [ngClass]="{ 'text-danger': reference.invalid && reference.touched }">
                                                <ng-select [items]="r" bindValue="valueId" bindLabel="name"
                                                    class="custom" [virtualScroll]="true" [loading]="loadValues"
                                                    name="reference{{i}}" loadingText="Cargando por favor espere..."
                                                    placeholder="Selecciona" [clearable]="false" [searchable]="false"
                                                    [(ngModel)]="x.refTypeId" #reference="ngModel">
                                                </ng-select>
                                                <div *ngIf="reference.errors && (reference.dirty || reference.touched)">
                                                    <span *ngIf="reference.errors.required">Requerido</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group" [ngClass]="{ 'text-danger': name3.invalid && name3.touched }">
                                                <input type="text" class="form-control form-control-sm" name="name3{{i}}"
                                                    [(ngModel)]="x.name" #name3="ngModel">
                                                <div *ngIf="name3.errors && (name3.dirty || name3.touched)">
                                                    <span *ngIf="name3.errors.required">Requerido</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group"
                                                [ngClass]="{ 'text-danger': relation.invalid && relation.touched }">
                                                <input type="text" class="form-control form-control-sm" name="relation{{i}}"
                                                    [(ngModel)]="x.relationship" #relation="ngModel">
                                                <div *ngIf="relation.errors && (relation.dirty || relation.touched)">
                                                    <span *ngIf="relation.errors.required">Requerido</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group"
                                                [ngClass]="{ 'text-danger': address3.invalid && address3.touched }">
                                                <input type="text" class="form-control form-control-sm" name="address3{{i}}"
                                                    [(ngModel)]="x.address" #address3="ngModel">
                                                <div *ngIf="address3.errors && (address3.dirty || address3.touched)">
                                                    <span *ngIf="address3.errors.required">Requerido</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group"
                                                [ngClass]="{ 'text-danger': department3.invalid && department3.touched }">
                                                <ng-select
                                                    (change)="c4 = $event ? $event.cities : null; x.ubication.localityId = null; x.ubication.cityId = null"
                                                    [items]="d" bindValue="valueId" bindLabel="name" class="custom"
                                                    [virtualScroll]="true" [loading]="loadValues" name="department3{{i}}"
                                                    [(ngModel)]="x.ubication.departmentId" placeholder="Selecciona"
                                                    loadingText="Cargando por favor espere..." #department3="ngModel"
                                                    notFoundText="No hay coincidencias" clearAllText="Limpiar todo">
                                                </ng-select>
                                                <div
                                                    *ngIf="department3.errors && (department3.dirty || department3.touched)">
                                                    <span *ngIf="department3.errors.required">Requerido</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group"
                                                [ngClass]="{ 'text-danger': city3.invalid && city3.touched }">
                                                <ng-select
                                                    (change)="l4 = $event ? $event.localities : null; x.ubication.localityId = null;"
                                                    [items]="c4" bindValue="valueId" bindLabel="name" class="custom"
                                                    [virtualScroll]="true" [readonly]="!department3.value"
                                                    [loading]="loadValues" loadingText="Cargando por favor espere..."
                                                    placeholder="Selecciona" notFoundText="No hay coincidencias"
                                                    clearAllText="Limpiar todo" [(ngModel)]="x.ubication.cityId"
                                                    name="city3{{i}}" #city3="ngModel">
                                                </ng-select>
                                                <div *ngIf="city3.errors && (city3.dirty || city3.touched)">
                                                    <span *ngIf="city3.errors.required">Requerido</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group"
                                                [ngClass]="{ 'text-danger': location3.invalid && location3.touched }">
                                                <ng-select [items]="l4" bindValue="valueId" bindLabel="name"
                                                    class="custom" [virtualScroll]="true"
                                                    [readonly]="!city3.value || l4.length === 0" [loading]="loadValues"
                                                    loadingText="Cargando por favor espere..." placeholder="Selecciona"
                                                    notFoundText="No hay coincidencias" name="location3{{i}}"
                                                    clearAllText="Limpiar todo" [(ngModel)]="x.ubication.localityId"
                                                    #location3="ngModel">
                                                </ng-select>
                                                <div *ngIf="location3.errors && (location3.dirty || location3.touched)">
                                                    <span *ngIf="location3.errors.required">Requerido</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group"
                                                [ngClass]="{ 'text-danger': phone3.invalid && phone3.touched }">
                                                <input type="text" class="form-control form-control-sm"
                                                    placeholder="(###) ### ####" name="phone3{{i}}" [imask]="phoneMask"
                                                    [unmask]="'typed'" [(ngModel)]="x.phone" #phone3="ngModel">
                                                <div *ngIf="phone3.errors && (phone3.dirty || phone3.touched)">
                                                    <span *ngIf="phone3.errors.required">Requerido</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <button type="button"
                                                class="btn btn-outline-danger btn-sm border-0 shadow-none font-weight-bold"
                                                title="Eliminar" (click)="removeReference(i)">
                                                <i class="fa fa-minus-circle"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header" role="tab" id="tituloAutorizacion" data-toggle="collapse"
                    data-target="#infoAutorizacion" aria-expanded="false" aria-controls="infoAutorizacion">
                    <h6 class="mb-0">Solicitud y autorización débito automático</h6>
                </div>
                <div id="infoAutorizacion" class="card-body collapse show" role="tabpanel"
                    aria-labelledby="tituloAutorizacion">
                    <!-- Fila 1 y 2 -->
                    <div class="row justify-content-center">
                        <div class="col-12 text-sm-center py-2">
                            <strong>Informacion de la empresa recaudadora</strong>
                        </div>
                        <div class="col-sm-12 col-lg-6 py-1">
                            <input class="form-control text-sm-center" type="text" readonly name="rec1"
                                value="CHEVYPLAN S.A. NIT. 830.001.133-7  Patrimonio Autonómo Fideicomiso ChevyPlan S.A.">
                        </div>
                        <div class="col-sm-12 col-lg-4 py-1">
                            <input class="form-control text-sm-center" type="text" readonly name="rec2"
                                value="Servicio a pagar cuota y demás rubros del contrato de autofinanciamiento">
                        </div>
                        <div class="col-sm-12 col-lg-2 py-1">
                            <input class="form-control text-sm-center" type="text" readonly name="rec3"
                                value="Código: 0.0.0.1">
                        </div>
                        <div class="col-12 text-sm-center py-2">
                            <strong>Información primer titutar de la cuenta</strong>
                        </div>
                        <div class="col-8 text-sm-center">
                            <div class="alert alert-dark" role="alert">
                                <!-- <a href="#infoSolicitante" target="_self">Ver "Información del solicitante"</a> -->
                                Ver "Información del solicitante"
                            </div>
                        </div>
                    </div>
                    <!-- Fila 3 -->
                    <div class="row" *ngIf="paymentCapacity.account?.secondHolder">
                        <div class="col-12 text-sm-center">
                            <strong>Información segundo titutar de la cuenta</strong>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <div class="form-group" [ngClass]="{ 'text-danger': name4.invalid && name4.touched }">
                                <label class="col-form-label col-form-label-sm">Nombre completo</label>
                                <input type="text" class="form-control form-control-sm" name="name4"
                                    [(ngModel)]="paymentCapacity.account.secondHolder.name" #name4="ngModel">
                                <div *ngIf="name4.errors && (name4.dirty || name4.touched)">
                                    <span *ngIf="name4.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': lastName4.invalid && lastName4.touched }">
                                <label class="col-form-label col-form-label-sm">Apellidos</label>
                                <input type="text" class="form-control form-control-sm" name="lastName4"
                                    [(ngModel)]="paymentCapacity.account.secondHolder.lastName" #lastName4="ngModel">
                                <div *ngIf="lastName4.errors && (lastName4.dirty || lastName4.touched)">
                                    <span *ngIf="lastName4.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': typeOfIdentity4.invalid && typeOfIdentity4.touched }">
                                <label class="col-form-label col-form-label-sm">Tipo de documento</label>
                                <ng-select [items]="td" bindValue="valueId" bindLabel="name" class="custom"
                                    [loading]="loadValues" loadingText="Cargando por favor espere..."
                                    [clearable]="false" [searchable]="false" name="typeOfIdentity4"
                                    [(ngModel)]="paymentCapacity.account.secondHolder.typeOfIdentity"
                                    #typeOfIdentity4="ngModel">
                                </ng-select>
                                <div
                                    *ngIf="typeOfIdentity4.errors && (typeOfIdentity4.dirty || typeOfIdentity4.touched)">
                                    <span *ngIf="typeOfIdentity4.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': documentNumber4.invalid && documentNumber4.touched }">
                                <label class="col-form-label col-form-label-sm">No. identificación</label>
                                <input type="text" class="form-control form-control-sm" name="documentNumber4"
                                    [(ngModel)]="paymentCapacity.account.secondHolder.documentNumber"
                                    #documentNumber4="ngModel">
                                <div
                                    *ngIf="documentNumber4.errors && (documentNumber4.dirty || documentNumber4.touched)">
                                    <span *ngIf="documentNumber4.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Fila 4 -->
                    <div class="row" *ngIf="paymentCapacity.account?.secondHolder">
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': expeditionDate4.invalid && expeditionDate4.touched }">
                                <label class="col-form-label col-form-label-sm">Fecha de expedición</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm text-center" ngbDatepicker
                                        #d5="ngbDatepicker" (click)="d5.toggle()" placeholder="Día/Mes/Año"
                                        [maxDate]="hoy" readonly name="expeditionDate4"
                                        [(ngModel)]="paymentCapacity.account.secondHolder.expDate"
                                        #expeditionDate4="ngModel">
                                    <button class="btn btn-info btn-sm" (click)="d5.toggle()" type="button">
                                        <i class="fa fa-calendar"></i>
                                    </button>
                                </div>
                                <div
                                    *ngIf="expeditionDate4.errors && (expeditionDate4.dirty || expeditionDate4.touched)">
                                    <span *ngIf="expeditionDate4.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': expeditionCity4.invalid && expeditionCity4.touched }">
                                <label class="col-form-label col-form-label-sm">Lugar de expedición</label>
                                <input type="text" class="form-control form-control-sm"
                                    [(ngModel)]="paymentCapacity.account.secondHolder.expCity" name="expeditionCity4"
                                    #expeditionCity4="ngModel">
                                <div
                                    *ngIf="expeditionCity4.errors && (expeditionCity4.dirty || expeditionCity4.touched)">
                                    <span *ngIf="expeditionCity4.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <div class="form-group" [ngClass]="{ 'text-danger': sex4.invalid && sex4.touched }">
                                <label class="col-form-label col-form-label-sm">Género</label>
                                <ng-select [items]="s" bindValue="valueId" bindLabel="name" class="custom"
                                    [loading]="loadValues" loadingText="Cargando por favor espere..."
                                    [clearable]="false" [searchable]="false" name="sex4"
                                    [(ngModel)]="paymentCapacity.account.secondHolder.sexId" #sex4="ngModel">
                                </ng-select>
                                <div *ngIf="sex4.errors && (sex4.dirty || sex4.touched)">
                                    <span *ngIf="sex4.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <div class="form-group" [ngClass]="{ 'text-danger': address4.invalid && address4.touched }">
                                <label class="col-form-label col-form-label-sm">Dirección</label>
                                <input type="text" class="form-control form-control-sm" name="address4"
                                    [(ngModel)]="paymentCapacity.account.secondHolder.address" #address4="ngModel">
                                <div *ngIf="address4.errors && (address4.dirty || address4.touched)">
                                    <span *ngIf="address4.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Fila 5 -->
                    <div class="row" *ngIf="paymentCapacity.account?.secondHolder">
                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <div class="form-group" [ngClass]="{ 'text-danger': phone4.invalid && phone4.touched }">
                                <label class="col-form-label col-form-label-sm">Teléfono</label>
                                <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####"
                                    [imask]="phoneMask" [unmask]="'typed'" name="phone4"
                                    [(ngModel)]="paymentCapacity.account.secondHolder.phone" #phone4="ngModel">
                                <div *ngIf="phone4.errors && (phone4.dirty || phone4.touched)">
                                    <span *ngIf="phone4.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': cellular4.invalid && cellular4.touched }">
                                <label class="col-form-label col-form-label-sm">Celular</label>
                                <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####"
                                    [imask]="cellularMask" [unmask]="true" name="cellular4"
                                    [(ngModel)]="paymentCapacity.account.secondHolder.cellPhone" #cellular4="ngModel">
                                <div *ngIf="cellular4.errors && (cellular4.dirty || cellular4.touched)">
                                    <span *ngIf="cellular4.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4">
                            <div class="form-group" [ngClass]="{ 'text-danger': email4.invalid && email4.touched }">
                                <label class="col-form-label col-form-label-sm">Correo electrónico</label>
                                <input type="text" class="form-control form-control-sm"
                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" name="email4"
                                    [(ngModel)]="paymentCapacity.account.secondHolder.email" #email4="ngModel">
                                <div *ngIf="email4.errors && (email4.dirty || email4.touched)">
                                    <span *ngIf="email4.errors.required">Requerido</span>
                                    <span *ngIf="email4.errors.pattern">Formato email incorrecto</span>
                                    <!-- <span *ngIf="email4.errors.existEmail">El email ya esta en uso</span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Fila 6 -->
                    <div class="row">
                        <div class="col-12 text-sm-center">
                            <strong>Información financiera de la cuenta</strong>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <div class="form-group" [ngClass]="{ 'text-danger': bank.invalid && bank.touched }">
                                <label class="col-form-label col-form-label-sm">
                                    <!-- Nombre de la e -->Entidad financiera</label>
                                <input type="text" class="form-control form-control-sm" name="bank"
                                    [(ngModel)]="paymentCapacity.account.financialEntity" #bank="ngModel">
                                <div *ngIf="bank.errors && (bank.dirty || bank.touched)">
                                    <span *ngIf="bank.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': accountNumber.invalid && accountNumber.touched }">
                                <label class="col-form-label col-form-label-sm">No. de cuenta</label>
                                <input type="text" class="form-control form-control-sm" name="accountNumber"
                                    [(ngModel)]="paymentCapacity.account.accountNumber" #accountNumber="ngModel" maxlength="15">
                                <div *ngIf="accountNumber.errors && (accountNumber.dirty || accountNumber.touched)">
                                    <span *ngIf="accountNumber.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <div class="form-group"
                                [ngClass]="{ 'text-danger': accountType.invalid && accountType.touched }">
                                <label class="col-form-label col-form-label-sm">Tipo de cuenta</label>
                                <ng-select [items]="tcs" bindValue="valueId" bindLabel="name" class="custom"
                                    [loading]="loadValues" loadingText="Cargando por favor espere..." name="accountType"
                                    placeholder="Selecciona" [clearable]="false" [searchable]="false"
                                    [(ngModel)]="paymentCapacity.account.accountTypeId" #accountType="ngModel">
                                </ng-select>
                                <div *ngIf="accountType.errors && (accountType.dirty || accountType.touched)">
                                    <span *ngIf="accountType.errors.required">Requerido</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <!-- <div class="form-group"
                                    [ngClass]="{ 'text-danger': department4.invalid && department4.touched }">
                                    <label class="col-form-label col-form-label-sm">Departamento</label>
                                    <ng-select (change)="c5 = $event ? $event.cities : null" [items]="d"
                                        bindValue="valueId" bindLabel="name" class="custom" [virtualScroll]="true"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..."
                                        placeholder="Selecciona" notFoundText="No hay coincidencias"
                                        clearAllText="Limpiar todo" name="department4" #department4="ngModel">
                                    </ng-select>
                                    <div *ngIf="department4.errors && (department4.dirty || department4.touched)">
                                        <span *ngIf="department4.errors.required">Requerido</span>
                                    </div>
                                </div> -->
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <!-- <div class="form-group" [ngClass]="{ 'text-danger': city4.invalid && city4.touched }">
                                    <label class="col-form-label col-form-label-sm">Ciudad</label>
                                    <ng-select (change)="l5 = $event ? $event.localities : null" [items]="c5"
                                        bindValue="valueId" bindLabel="name" class="custom" [virtualScroll]="true"
                                        [readonly]="!department4.value" [loading]="loadValues" name="city4"
                                        loadingText="Cargando por favor espere..." placeholder="Selecciona"
                                        notFoundText="No hay coincidencias" clearAllText="Limpiar todo"
                                        #city4="ngModel">
                                    </ng-select>
                                    <div *ngIf="city4.errors && (city4.dirty || city4.touched)">
                                        <span *ngIf="city4.errors.required">Requerido</span>
                                    </div>
                                </div> -->
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-2">
                            <!-- <div class="form-group"
                                    [ngClass]="{ 'text-danger': location4.invalid && location4.touched }">
                                    <label class="col-form-label col-form-label-sm">Localidad</label>
                                    <ng-select [items]="l5" bindValue="valueId" bindLabel="name" class="custom"
                                        [virtualScroll]="true" [readonly]="!city4.value || l5.length === 0" name="location4"
                                        [loading]="loadValues" loadingText="Cargando por favor espere..."
                                        placeholder="Selecciona" notFoundText="No hay coincidencias"
                                        clearAllText="Limpiar todo" #location4="ngModel">
                                    </ng-select>
                                    <div *ngIf="location4.errors && (location4.dirty || location4.touched)">
                                        <span *ngIf="location4.errors.required">Requerido</span>
                                    </div>
                                </div> -->
                        </div>
                    </div>
                    <!-- Fila 7 -->
                    <div class="row justify-content-center">
                        <div class="col-10 text-sm-center">
                            <div class="alert alert-dark py-3" role="alert">
                                Información relacionada con el servicio de débito automático
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header" role="tab" id="tituloDebito" data-toggle="collapse" data-target="#infoDebito"
                    aria-expanded="false" aria-controls="infoDebito">
                    <h6 class="mb-0">Reglamento autorización débito automático</h6>
                </div>
                <div id="infoDebito" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloDebito">
                    <!-- Fila 1 -->
                    <div class="row">
                        <div class="col-12 text-sm-center">
                            <div class="alert alert-dark py-3" role="alert">
                                <div class="row">
                                    <div class="col-2">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" id="customSwitch1">
                                            <label class="custom-control-label" for="customSwitch1">Ver
                                                Información</label>
                                        </div>
                                    </div>
                                    <div class="col-10 text-center">
                                        Texto largo (alrededor de 24 renglones)
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header" role="tab" id="tituloPeps" data-toggle="collapse" data-target="#infoPeps"
                    aria-expanded="false" aria-controls="infoPeps">
                    <h6 class="mb-0">PEPS: Personas Expuestas Públicas o Politicamente</h6>
                </div>
                <div id="infoPeps" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloPeps">
                    <!-- Fila 1 -->
                    <div class="form-group row justify-content-center">
                        <div class="col-sm-12 col-md-6 col-lg-4 text-md-right">¿Maneja o manejó recursos públicos?
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-1">
                            <ng-select
                                (change)="peps1.value === 'Si' ? requiredField(pepsDesc1) : resetField(pepsDesc1)"
                                class="custom" [loading]="loadValues" loadingText="Cargando por favor espere..."
                                [clearable]="false" [searchable]="false" name="peps1"
                                [(ngModel)]="paymentCapacity.peps.pepsResponse1" #peps1="ngModel">
                                <ng-option value="Si">Si</ng-option>
                                <ng-option value="No">No</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-1 text-md-right">Explique</div>
                        <div class="col-sm-12 col-md-6 col-lg-4"
                            [ngClass]="{ 'text-danger': pepsDesc1.invalid && pepsDesc1.touched }">
                            <textarea class="form-control form-control-sm" placeholder="" name="pepsDesc1"
                                [readonly]="peps1.value === 'No'" [(ngModel)]="paymentCapacity.peps.pepsDescription1"
                                #pepsDesc1="ngModel"></textarea>
                            <div *ngIf="pepsDesc1.errors && (pepsDesc1.dirty || pepsDesc1.touched)">
                                <span *ngIf="pepsDesc1.errors.required">Requerido</span>
                            </div>
                        </div>
                    </div>
                    <!-- Fila 2 -->
                    <div class="form-group row justify-content-center">
                        <div class="col-sm-12 col-md-6 col-lg-4 text-md-right">¿Desempeña o ha desempeñado algún
                            cargo público?</div>
                        <div class="col-sm-12 col-md-6 col-lg-1">
                            <ng-select
                                (change)="peps2.value === 'Si' ? requiredField(pepsDesc2) : resetField(pepsDesc2)"
                                class="custom" [loading]="loadValues" loadingText="Cargando por favor espere..."
                                [clearable]="false" [searchable]="false" name="peps2"
                                [(ngModel)]="paymentCapacity.peps.pepsResponse2" #peps2="ngModel">
                                <ng-option value="Si">Si</ng-option>
                                <ng-option value="No">No</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-1 text-md-right">Cuál</div>
                        <div class="col-sm-12 col-md-6 col-lg-4"
                            [ngClass]="{ 'text-danger': pepsDesc2.invalid && pepsDesc2.touched }">
                            <textarea class="form-control form-control-sm" placeholder="" name="pepsDesc2"
                                [readonly]="peps2.value === 'No'" [(ngModel)]="paymentCapacity.peps.pepsDescription2"
                                #pepsDesc2="ngModel"></textarea>
                            <div *ngIf="pepsDesc2.errors && (pepsDesc2.dirty || pepsDesc2.touched)">
                                <span *ngIf="pepsDesc2.errors.required">Requerido</span>
                            </div>
                        </div>
                    </div>
                    <!-- Fila 3 -->
                    <div class="form-group row justify-content-center">
                        <div class="col-sm-12 col-md-6 col-lg-4 text-md-right">
                            ¿Goza o gozó de reconocimiento público?
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-1">
                            <ng-select
                                (change)="peps3.value === 'Si' ? requiredField(pepsDesc3) : resetField(pepsDesc3)"
                                class="custom" [loading]="loadValues" loadingText="Cargando por favor espere..."
                                [clearable]="false" [searchable]="false" name="peps3"
                                [(ngModel)]="paymentCapacity.peps.pepsResponse3" #peps3="ngModel">
                                <ng-option value="Si">Si</ng-option>
                                <ng-option value="No">No</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-1 text-md-right">Indique</div>
                        <div class="col-sm-12 col-md-6 col-lg-4"
                            [ngClass]="{ 'text-danger': pepsDesc3.invalid && pepsDesc3.touched }">
                            <textarea class="form-control form-control-sm" placeholder="" name="pepsDesc3"
                                [readonly]="peps3.value === 'No'" [(ngModel)]="paymentCapacity.peps.pepsDescription3"
                                #pepsDesc3="ngModel"></textarea>
                            <div *ngIf="pepsDesc3.errors && (pepsDesc3.dirty || pepsDesc3.touched)">
                                <span *ngIf="pepsDesc3.errors.required">Requerido</span>
                            </div>
                        </div>
                    </div>
                    <!-- Fila 4 -->
                    <div class="form-group row justify-content-center">
                        <div class="col-sm-12 col-md-6 col-lg-4 text-md-right">¿Existe algún vínculo de
                            consanguineidad entre usted y algún funcionario público?</div>
                        <div class="col-sm-12 col-md-6 col-lg-1">
                            <ng-select
                                (change)="peps4.value === 'Si' ? requiredField(pepsDesc4) : resetField(pepsDesc4)"
                                class="custom" [loading]="loadValues" loadingText="Cargando por favor espere..."
                                [clearable]="false" [searchable]="false" name="peps4"
                                [(ngModel)]="paymentCapacity.peps.pepsResponse4" #peps4="ngModel">
                                <ng-option value="Si">Si</ng-option>
                                <ng-option value="No">No</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-1 text-md-right">Indique</div>
                        <div class="col-sm-12 col-md-6 col-lg-4"
                            [ngClass]="{ 'text-danger': pepsDesc4.invalid && pepsDesc4.touched }">
                            <textarea class="form-control form-control-sm mt-2" placeholder=""
                                [readonly]="peps4.value === 'No'" [(ngModel)]="paymentCapacity.peps.pepsDescription4"
                                name="pepsDesc4" #pepsDesc4="ngModel"></textarea>
                            <div *ngIf="pepsDesc4.errors && (pepsDesc4.dirty || pepsDesc4.touched)">
                                <span *ngIf="pepsDesc4.errors.required">Requerido</span>
                            </div>
                        </div>
                    </div>
                    <!-- Fila 5 -->
                </div>
            </div>
            <div class="card">
                <div class="card-header" role="tab" id="tituloDeclaraciones" data-toggle="collapse"
                    data-target="#infoDeclaraciones" aria-expanded="false" aria-controls="infoDeclaraciones">
                    <h6 class="mb-0">Autorizaciones y Declaraciones</h6>
                </div>
                <div id="infoDeclaraciones" class="card-body collapse show" role="tabpanel"
                    aria-labelledby="tituloDeclaraciones">
                    <!-- Fila 1 -->
                    <div class="row justify-content-center">
                        <div class="col-10 text-sm-center">
                            <div class="alert alert-dark py-5" role="alert">
                                Texto informativo (muy largo)
                            </div>
                        </div>
                    </div>
                    <!-- Fila 2 -->
                    <div class="form-group row">
                        <div class="col-3 text-right">Nombre</div>
                        <div class="col-4"><input class="form-control form-control-sm" type="text" name="name5"
                                [(ngModel)]="paymentCapacity.authorizeDeclare.name" #name5="ngModel">
                        </div>
                    </div>
                    <!-- Fila 3 -->
                    <div class="form-group row">
                        <div class="col-3 text-right">No. identificación</div>
                        <div class="col-4">
                            <input class="form-control form-control-sm" type="text"
                                [(ngModel)]="paymentCapacity.authorizeDeclare.documentNumber" name="documentNumber5"
                                #documentNumber5="ngModel">
                        </div>
                    </div>
                    <!-- Fila 4 -->
                    <!-- <div class="form-group row">
                        <div class="col-3 text-right">En nombre propio</div>
                        <div class="col-2"><input class="form-control form-control-sm" type="text" name="ownName"
                                [(ngModel)]="paymentCapacity.authorizeDeclare.inYourOwnName" #ownName="ngModel">
                        </div>
                        <div class="col-2 text-center">Representante legal</div>
                        <div class="col-3">
                            <input class="form-control form-control-sm" type="text" name="legal"
                                [(ngModel)]="paymentCapacity.authorizeDeclare.legalRepresentative" #legal="ngModel">
                        </div>
                    </div> -->
                    <!-- Fila 5 -->
                    <!-- <div class="form-group row">
                        <div class="col-3 text-right">Apoderado</div>
                        <div class="col-2"><input class="form-control form-control-sm" type="text" name="attorney"
                                [(ngModel)]="paymentCapacity.authorizeDeclare.attorney" #attorney="ngModel"></div>
                        <div class="col-1 text-center">de</div>
                        <div class="col-3"><input class="form-control form-control-sm" type="text" name="attorneyName"
                                [(ngModel)]="paymentCapacity.authorizeDeclare.thirdName" #attorneyName="ngModel"></div>
                    </div> -->
                    <!-- Fila 6 -->
                    <div class="form-group row">
                        <div class="col-3 text-right">No. identificación</div>
                        <div class="col-3">
                            <input class="form-control form-control-sm" type="text"
                                [(ngModel)]="paymentCapacity.authorizeDeclare.thirdDocumentNumber"
                                name="attorneyDocumentNumber" #attorneyDocumentNumber="ngModel">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row text-center justify-content-center mt-2" *ngIf="!viewMode">
                <div class="col-12">
                    <button class="btn btn-primary font-weight-bold m-2" title="Guardar">
                        <i class="fa fa-save"></i>
                        Guardar
                    </button>
                    <button class="btn btn-primary font-weight-bold m-2" title="Enviar">
                        <i class="fa fa-envelope-o"></i>
                        Enviar
                    </button>
                </div>
            </div>
        </form>
        <!-- <app-loading [loading]="loading"></app-loading> -->
    </div>
</div>
